import Sim from "global/images/dashboard/sim.png";
import Topup from "global/images/dashboard/topup.png";
import Card from "global/images/dashboard/card.png";
import Data from "global/images/dashboard/data.png";
import Bill from "global/images/dashboard/bill.png";
import Wifi from "global/images/dashboard/wifi.png";
import Water from "global/images/dashboard/water.png";
import Tivi from "global/images/dashboard/tivi.png";
import Pikachu from "global/images/dashboard/pikachu.png";

export class DashboardConstants {
  private static itemNav = [
    {
      key: "sim",
      label: "Sim số",
      image: Sim,
      path: "/order/dkttb",
      disabled: false,
      color: "#1890ff",
    },
    {
      key: "topup",
      label: "Topup",
      image: Topup,
      path: "/order/topup",
      disabled: false,
      color: "#52c41a",
    },
    {
      key: "card",
      label: "Mã thẻ",
      image: Card,
      path: "/order/topup",
      disabled: false,
      color: "#faad14",
    },
    {
      key: "data",
      label: "Data",
      image: Data,
      path: "/order/data",
      disabled: false,
      color: "#13c2c2",
    },
    {
      key: "bill",
      label: "Thanh toán hóa đơn",
      image: Bill,
      path: "/bill",
      disabled: true,
      color: "#722ed1",
    },
    {
      key: "electric",
      label: "Tiền điện",
      image: Pikachu,
      path: "/electric",
      disabled: true,
      color: "#f5222d",
    },
    {
      key: "water",
      label: "Tiền nước",
      image: Water,
      path: "/water",
      disabled: true,
      color: "#40a9ff",
    },
    {
      key: "internet",
      label: "Internet",
      image: Wifi,
      path: "/internet",
      disabled: true,
      color: "#eb2f96",
    },
    {
      key: "tv",
      label: "Truyền hình",
      image: Tivi,
      path: "/tv",
      disabled: true,
      color: "#a0d911",
    },
  ];

  static render() {
    return {
      itemNav: this.itemNav,
    };
  }
}
